import { Archetype, CARD_RULE_EXPLAINATION_MAP } from "../../models/Archetype"

export type ArchetypeRulesProps = {
    archetype: Archetype
}

export function ArchetypeRules(props: ArchetypeRulesProps) {
    return (
        <div className="bg-primary shadow-lg rounded border border-color-border p-4">
            <div className="font-semibold mb-4">Deck contains:</div>
            <div className="flex flex-col gap-2">
                {
                    props.archetype.rules.map((rule, index) => {
                        const textFunction = CARD_RULE_EXPLAINATION_MAP[rule.type];
                        const text = textFunction ? textFunction(rule) : "";
                        return <div key={index} className=" whitespace-pre-wrap">{text}</div>
                    })
                }
            </div>
        </div>
    )
}